import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: "Roguehaven's unified reporting saves my team over 15 hours a week. We no longer build reports; we just analyze the insights.",
  name: 'Thessaly Voss',
  role: 'Performance Director',
  agency: 'Keldra Media'
}, {
  quote: 'The Pulse Monitor anomaly detection caught a €40K budget bleed on a weekend that we would have otherwise missed until Monday.',
  name: 'Caius Maren',
  role: 'Founder',
  agency: 'Obsidian Reach'
}, {
  quote: 'Client retention has improved dramatically. Giving them access to real-time, transparent dashboards builds a level of trust spreadsheets never could.',
  name: 'Ondine Kreth',
  role: 'Head of Paid Media',
  agency: 'Vantara Group'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-6 bg-navy-900 border-t border-navy-700/50" data-id="element-275">
      <div className="max-w-7xl mx-auto" data-id="element-276">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-277">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy-800 border border-navy-700 rounded-xl p-8 relative" data-id="element-278">
              <QuoteIcon className="w-10 h-10 text-navy-700 absolute top-6 right-6" data-id="element-279" />
              <p className="text-gray-300 leading-relaxed mb-8 relative z-10" data-id="element-280">
                "{testimonial.quote}"
              </p>
              <div data-id="element-281">
                <p className="text-white font-semibold" data-id="element-282">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-283">
                  {testimonial.role},{' '}
                  <span className="text-accent-teal" data-id="element-284">{testimonial.agency}</span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}